export default __webpack_public_path__ + "static/media/Bracers of Conflagrant Flame.164cba1c.jpg";